import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset Your Password"
      subtitle={done ? null : "Enter your email and we'll generate a reset link"}
      footer={<Link to="/login" className="prose-link font-semibold" data-testid="link-back-login">Back to Login</Link>}
    >
      {done ? (
        <div className="text-center" data-testid="forgot-done">
          <MailCheck size={40} className="mx-auto text-[#16A34A]" />
          <p className="mt-3 text-sm text-gray-700">
            If an account exists for <strong>{email}</strong>, a password reset link has been generated.
          </p>
          <p className="mt-2 rounded-sm bg-[#FEF3C7] p-3 text-xs text-[#92400E]">
            The reset link is valid for 1 hour. Don't see the email? Please check your spam/promotions folder.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <label className="mb-1 block text-sm font-semibold text-[#0B2545]">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-sm border border-[#D1D5DB] px-3 py-2 text-sm focus:border-[#1F3A68]" data-testid="forgot-email" />
          </div>
          {error && <p className="rounded-sm bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <button type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-sm bg-[#1F3A68] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#0B2545] disabled:opacity-60" data-testid="forgot-submit">
            {loading && <Loader2 size={16} className="animate-spin" />} Send Reset Link
          </button>
        </form>
      )}
    </AuthShell>
  );
}
